import { generateSimpleAction } from 'utils/actionHelpers'

export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const OPEN_NOTIFICATIONS = 'OPEN_NOTIFICATIONS'
export const REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS'
export const addNotifications = generateSimpleAction(ADD_NOTIFICATIONS)
export const openNotifications = generateSimpleAction(OPEN_NOTIFICATIONS)
export const removeNotifications = generateSimpleAction(REMOVE_NOTIFICATIONS)
